module.exports = __webpack_public_path__ + "static/img/mz.8109408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mz.png
// module id = 2uU5
// module chunks = 2